import { IHoliday } from "../holidayTypes";

export const FinlandHolidays: { [key: string]: IHoliday } = {
  // 2024
  "2024-01-01": { title: "Uudenvuodenpäivä", type: "HOLIDAY" },
  "2024-01-06": { title: "Loppiainen", type: "HOLIDAY" },
  "2024-03-29": { title: "Pitkäperjantai", type: "HOLIDAY" },
  "2024-03-31": { title: "Pääsiäispäivä", type: "HOLIDAY" },
  "2024-04-01": { title: "2. pääsiäispäivä", type: "HOLIDAY" },
  "2024-05-01": { title: "Vappu", type: "HOLIDAY" },
  "2024-05-09": { title: "Helatorstai", type: "HOLIDAY" },
  "2024-05-19": { title: "Helluntaipäivä", type: "HOLIDAY" },
  "2024-06-21": { title: "Juhannusaatto", type: "SPECIAL_DAY" },
  "2024-06-22": { title: "Juhannuspäivä", type: "HOLIDAY" },
  "2024-11-02": { title: "Pyhäinpäivä", type: "HOLIDAY" },
  "2024-12-06": { title: "Itsenäisyyspäivä", type: "HOLIDAY" },
  "2024-12-24": { title: "Jouluaatto", type: "SPECIAL_DAY" },
  "2024-12-25": { title: "Joulupäivä", type: "HOLIDAY" },
  "2024-12-26": { title: "Tapaninpäivä", type: "HOLIDAY" },

  // 2025
  "2025-01-01": { title: "Uudenvuodenpäivä", type: "HOLIDAY" },
  "2025-01-06": { title: "Loppiainen", type: "HOLIDAY" },
  "2025-02-14": { title: "Ystävänpäivä", type: "SPECIAL_DAY" },
  "2025-04-18": { title: "Pitkäperjantai", type: "HOLIDAY" },
  "2025-04-20": { title: "Pääsiäispäivä", type: "HOLIDAY" },
  "2025-04-21": { title: "2. pääsiäispäivä", type: "HOLIDAY" },
  "2025-05-01": { title: "Vappu", type: "HOLIDAY" },
  "2025-05-11": { title: "Äitienpäivä", type: "SPECIAL_DAY" },
  "2025-05-29": { title: "Helatorstai", type: "HOLIDAY" },
  "2025-06-08": { title: "Helluntaipäivä", type: "HOLIDAY" },
  "2025-06-20": { title: "Juhannusaatto", type: "SPECIAL_DAY" },
  "2025-06-21": { title: "Juhannuspäivä", type: "HOLIDAY" },
  "2025-11-01": { title: "Pyhäinpäivä", type: "HOLIDAY" },
  "2025-11-09": { title: "Isänpäivä", type: "SPECIAL_DAY" },
  "2025-12-06": { title: "Itsenäisyyspäivä", type: "HOLIDAY" },
  "2025-12-24": { title: "Jouluaatto", type: "SPECIAL_DAY" },
  "2025-12-25": { title: "Joulupäivä", type: "HOLIDAY" },
  "2025-12-26": { title: "Tapaninpäivä", type: "HOLIDAY" },
  "2025-12-31": { title: "Uudenvuodenaatto", type: "SPECIAL_DAY" },

  // 2026
  "2026-01-01": { title: "Uudenvuodenpäivä", type: "HOLIDAY" },
  "2026-01-06": { title: "Loppiainen", type: "HOLIDAY" },
  "2026-02-14": { title: "Ystävänpäivä", type: "SPECIAL_DAY" },
  "2026-04-03": { title: "Pitkäperjantai", type: "HOLIDAY" },
  "2026-04-05": { title: "Pääsiäispäivä", type: "HOLIDAY" },
  "2026-04-06": { title: "2. pääsiäispäivä", type: "HOLIDAY" },
  "2026-05-01": { title: "Vappu", type: "HOLIDAY" },
  "2026-05-10": { title: "Äitienpäivä", type: "SPECIAL_DAY" },
  "2026-05-14": { title: "Helatorstai", type: "HOLIDAY" },
  "2026-05-24": { title: "Helluntaipäivä", type: "HOLIDAY" },
  "2026-06-19": { title: "Juhannusaatto", type: "SPECIAL_DAY" },
  "2026-06-20": { title: "Juhannuspäivä", type: "HOLIDAY" },
  "2026-10-31": { title: "Pyhäinpäivä", type: "HOLIDAY" },
  "2026-11-08": { title: "Isänpäivä", type: "SPECIAL_DAY" },
  "2026-12-06": { title: "Itsenäisyyspäivä", type: "HOLIDAY" },
  "2026-12-24": { title: "Jouluaatto", type: "SPECIAL_DAY" },
  "2026-12-25": { title: "Joulupäivä", type: "HOLIDAY" },
  "2026-12-26": { title: "Tapaninpäivä", type: "HOLIDAY" },
  "2026-12-31": { title: "Uudenvuodenaatto", type: "SPECIAL_DAY" },

  // 2027
  "2027-01-01": { title: "Uudenvuodenpäivä", type: "HOLIDAY" },
  "2027-01-06": { title: "Loppiainen", type: "HOLIDAY" },
  "2027-02-14": { title: "Ystävänpäivä", type: "SPECIAL_DAY" },
  "2027-03-26": { title: "Pitkäperjantai", type: "HOLIDAY" },
  "2027-03-28": { title: "Pääsiäispäivä", type: "HOLIDAY" },
  "2027-03-29": { title: "2. pääsiäispäivä", type: "HOLIDAY" },
  "2027-05-01": { title: "Vappu", type: "HOLIDAY" },
  "2027-05-06": { title: "Helatorstai", type: "HOLIDAY" },
  "2027-05-09": { title: "Äitienpäivä", type: "SPECIAL_DAY" },
  "2027-05-16": { title: "Helluntaipäivä", type: "HOLIDAY" },
  "2027-06-25": { title: "Juhannusaatto", type: "SPECIAL_DAY" },
  "2027-06-26": { title: "Juhannuspäivä", type: "HOLIDAY" },
  "2027-11-06": { title: "Pyhäinpäivä", type: "HOLIDAY" },
  "2027-11-14": { title: "Isänpäivä", type: "SPECIAL_DAY" },
  "2027-12-06": { title: "Itsenäisyyspäivä", type: "HOLIDAY" },
  "2027-12-24": { title: "Jouluaatto", type: "SPECIAL_DAY" },
  "2027-12-25": { title: "Joulupäivä", type: "HOLIDAY" },
  "2027-12-26": { title: "Tapaninpäivä", type: "HOLIDAY" },
  "2027-12-31": { title: "Uudenvuodenaatto", type: "SPECIAL_DAY" },
};



// WEBPACK FOOTER //
// ./src/constants/holidays/europe/finlandHolidays.ts